import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, useMemo } from "react";
import { Dropdown } from "../Dropdown.js";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { Icon } from "../Icon/Icon.js";
import { Box } from "../Box/Box.js";
import { Button } from "../Forms/Button/Button.js";
const commonButtonProps = {
  size: "small",
  flow: "circular"
};
const commonIconProps = {
  size: "small"
};
const ActionableBox = memo(({ className, children, editContents, onRemove }) => {
  const prefix = useClassNamePrefix();
  const buttonProps = useMemo(() => ({
    ...commonButtonProps,
    children: /* @__PURE__ */ jsx(Icon, { ...commonIconProps, contemberIcon: "pencil" })
  }), []);
  if (editContents === void 0 && onRemove === void 0) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsxs(Box, { className: classNames(
    `${prefix}actionableBox`,
    className
  ), children: [
    /* @__PURE__ */ jsx("div", { className: `${prefix}actionableBox-contents`, children }),
    /* @__PURE__ */ jsxs("ul", { className: `${prefix}actionableBox-actions`, contentEditable: false, children: [
      editContents && /* @__PURE__ */ jsx("li", { className: `${prefix}actionableBox-action`, children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          buttonProps,
          children: /* @__PURE__ */ jsx(Fragment, { children: editContents })
        }
      ) }),
      onRemove && /* @__PURE__ */ jsx("li", { className: `${prefix}actionableBox-action`, children: /* @__PURE__ */ jsx(Button, { intent: "danger", ...commonButtonProps, onClick: onRemove, children: /* @__PURE__ */ jsx(Icon, { ...commonIconProps, blueprintIcon: "trash" }) }) })
    ] })
  ] });
});
ActionableBox.displayName = "ActionableBox";
export {
  ActionableBox
};
//# sourceMappingURL=ActionableBox.js.map
